/**
 * Responsive navigation
 */
import {isDesktop} from "../plugins/Helpers";

// Move checkout widgets from end of body directly into .header-inside
const checkoutWidgets = document.getElementById('checkout-widgets');
const headerInside = document.querySelector('.header-inside');
if (checkoutWidgets && headerInside) {
    while (checkoutWidgets.firstChild) {
        headerInside.appendChild(checkoutWidgets.firstChild);
    }
    checkoutWidgets.remove();
}

recalculatePageOffset();
document.addEventListener('scroll', () => {
    toggleScrolled();
    recalculatePageOffset();
});

window.addEventListener('resize', () => {
    recalculatePageOffset();
});

document.addEventListener('headerBarClose', () => {
    recalculatePageOffset();
});
document.addEventListener('topNavMounted', () => {
    recalculatePageOffset();
});

/**
 * dense header
 */
const showNavigationButton = document.querySelector('.header-show-navigation');
if (showNavigationButton) {
    showNavigationButton.addEventListener('click', function () {
        document.querySelector('.header-inside').classList.add('show-nav');
    });
}

const navToggle = document.querySelector("header .header-inside .nav-toggle");
if (navToggle) {
    navToggle.addEventListener('click', function (e) {
        e.preventDefault();
        const headerInside = document.querySelector("header .header-inside");
        const header = document.querySelector("header");
        if (e.target.classList.contains("active")) {
            header.classList.remove('active');
            headerInside.classList.remove('active');
            document.getElementsByTagName("html")[0].classList.remove("nav-open");
            document.getElementsByTagName("body")[0].classList.remove("nav-open");
            toggleMenuIcons('close');
            e.target.classList.remove("active");
            document.querySelector(".main-navigation").style.display = 'none';
        } else {
            header.classList.add('active');
            headerInside.classList.add('active');
            document.getElementsByTagName("html")[0].classList.add("nav-open");
            document.getElementsByTagName("body")[0].classList.add("nav-open");
            toggleMenuIcons('open');
            e.target.classList.add("active");
            document.querySelector(".main-navigation").style.display = 'block';
        }
    });
}

/**
 * Header cross-country redirect bar
 */
const crossCountryRedirect = document.querySelector('header .cross-country-redirects .cross-country-redirects-close');
if (crossCountryRedirect) {
    crossCountryRedirect.addEventListener('click', (e) => {
        e.preventDefault();
        crossCountryRedirect.parentElement.remove();
        window.Cookies.set('cross_country_redirect_denied', 1);
        document.dispatchEvent(new Event('headerBarClose'));
    });
}

function toggleScrolled() {
    if (window.scrollY > 200) {
        if (!document.querySelector('body').classList.contains('scrolled')) {
            document.querySelector('body').classList.add('scrolled');
        }
    } else if (document.querySelector('body').classList.contains('scrolled')) {
        document.querySelector('body').classList.remove('scrolled');
    }
}

function recalculatePageOffset() {
    const header = document.getElementById('header');
    if (!header) {
        return;
    }

    if (header.classList.contains('transparent-header')) {
        return;
    }

    if (isDesktop()) {
        document.querySelector('body').style.paddingTop = header.clientHeight.toString() + 'px';
    } else {
        if (document.querySelector('body').classList.contains('scrolled')) {
            header.style.top = ((header.clientHeight + 1) * -1).toString() + 'px';
        } else {
            document.querySelector('body').style.paddingTop = header.clientHeight.toString() + 'px';
            header.style.top = '0px';
        }
    }
}

function toggleMenuIcons(state) {
    const links = document.querySelectorAll('ul.level-2 li a');
    for (let link of links) {
        if (state === 'open' && link.dataset['iconResponsive']) {
            link.style.backgroundImage = `url(${link.dataset['iconResponsive']})`;
        } else if (link.dataset['iconDesktop']) {
            link.style.backgroundImage = `url(${link.dataset['iconDesktop']})`;
        }
    }
}

// Scroll to anchor
document.addEventListener('click', function(e) {
    if (e.target.tagName === 'A') {
        if (e.target.hash && e.target.target !== '_blank') {
            e.preventDefault();

            let targetId = e.target.hash.substring(1);
            let targetElement = document.getElementById(targetId);

            if (targetElement) {
                let targetOffset = targetElement.getBoundingClientRect().top;
                window.scrollTo({
                    top: window.pageYOffset + targetOffset - 150,
                    behavior: 'smooth'
                });
            } else {
                window.location.href = `${e.target.href}`;
            }
        } else if (e.target.target === '_blank') {
            return;
        }
    }
});

// Scroll to anchor from another page or on page load
document.addEventListener('DOMContentLoaded', function() {
    let fragment = window.location.hash;
    if (fragment) {
        let targetId = fragment.substring(1);
        let checkExist = setInterval(function() {
            let targetElement = document.getElementById(targetId);
            if (targetElement) {
                clearInterval(checkExist);
                let targetOffset = targetElement.getBoundingClientRect().top;
                window.scrollTo({
                    top: window.pageYOffset + targetOffset - 150,
                    behavior: 'smooth'
                });
            }
        }, 100); // Check every 100ms
    }
});
